import en from './en';
import es from './es';
import it from './it';
import zh from './zh';
import de from './de';
import pl from './pl';
import { iaEn, iaEs } from './ia';
import { iaDe } from './ia-de';
import { iaIt } from './ia-it';
import { iaPl } from './ia-pl';
import { iaZh } from './ia-zh';
import { extraEn, extraEs, extraDe, extraIt, extraPl, extraZh } from './extra';
import { restEn, restEs, restDe, restIt, restPl, restZh } from './rest';
import { yggEn, yggEs, yggDe, yggIt, yggPl, yggZh } from './yggdrasil';
import { isSupportedLanguage } from './languages';

function deepMerge(target, source) {
  if (!source) return target;
  const out = { ...(target || {}) };
  for (const [key, value] of Object.entries(source)) {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      out[key] = deepMerge(out[key], value);
    } else {
      out[key] = value;
    }
  }
  return out;
}

/** Keep existing locale leaves; only fill keys the locale does not have. */
function fillMissing(target, source) {
  if (source == null) return target;
  if (target == null) return source;
  if (Array.isArray(source)) return Array.isArray(target) ? target : source;
  if (typeof source !== 'object') return target !== undefined ? target : source;
  const out = { ...target };
  for (const [key, value] of Object.entries(source)) {
    if (!(key in out) || out[key] == null) {
      out[key] = value;
    } else if (
      value && typeof value === 'object' && !Array.isArray(value)
      && out[key] && typeof out[key] === 'object' && !Array.isArray(out[key])
    ) {
      out[key] = fillMissing(out[key], value);
    }
  }
  return out;
}

function assemble(base, iaOverlay, extra, rest, ygg) {
  return deepMerge(deepMerge(deepMerge(deepMerge(fillMissing(base, iaEn), iaOverlay), extra), rest), ygg);
}

export const translations = {
  en: assemble(en, iaEn, extraEn, restEn, yggEn),
  es: assemble(es, iaEs, extraEs, restEs, yggEs),
  it: assemble(it, iaIt, extraIt, restIt, yggIt),
  zh: assemble(zh, iaZh, extraZh, restZh, yggZh),
  de: assemble(de, iaDe, extraDe, restDe, yggDe),
  pl: assemble(pl, iaPl, extraPl, restPl, yggPl),
};

let activeLanguage = 'en';

export function setActiveLanguage(language) {
  activeLanguage = isSupportedLanguage(language) ? language : 'en';
  return activeLanguage;
}

export function getActiveLanguage() {
  return activeLanguage;
}

export function asArray(value) {
  return Array.isArray(value) ? value : [];
}

function interpolate(str, vars) {
  if (!vars || typeof str !== 'string') return str;
  return str.replace(/\{(\w+)\}/g, (match, key) => (
    vars[key] != null ? String(vars[key]) : match
  ));
}

export const t = (key, language, vars) => {
  const lang = isSupportedLanguage(language) ? language : activeLanguage;
  const keys = String(key).split('.');
  let value = translations[lang];

  for (const k of keys) {
    value = value?.[k];
  }

  if ((value == null || value === '') && lang !== 'en') {
    let fallbackValue = translations.en;
    for (const k of keys) {
      fallbackValue = fallbackValue?.[k];
    }
    return interpolate(fallbackValue ?? key, vars);
  }

  return interpolate(value ?? key, vars);
};
